export const REPORT_CONFIGS = {
  'project-roster': {
    filters: [
      { type: 'event', label: 'Select Event', required: true, searchable: true }
    ],
    columns: [
      { field: 'gender', label: 'Gender' },
      { field: 'passportSurname', label: 'Passport Surname' },
      { field: 'passportGivenName', label: 'Passport Given Name' },
      { field: 'passportNumber', label: 'Passport Number' },
      { field: 'birthDate', label: 'Birth Date' },
      { field: 'placeOfBirth', label: 'Place of Birth' },
      { field: 'issueDate', label: 'Issue Date' },
      { field: 'expirationDate', label: 'Expiration Date' },
      { field: 'addressLine1', label: 'Address Line 1' },
      { field: 'addressLine2', label: 'Address Line 2' },
      { field: 'city', label: 'City' },
      { field: 'state', label: 'State' },
      { field: 'zipCode', label: 'ZIP Code' },
      { field: 'departureAirport', label: 'Departure Airport' },
      { field: 'departureDate', label: 'Departure Date' },
      { field: 'returnDate', label: 'Return Date' }
    ],
    buildApiUrl: (filters, format) => 
      `/api/reports/project-roster/${filters.eventId}?format=${format}`
  },
  
  'board-members': {
    filters: [
      { type: 'role', label: 'Select Role(s)', required: true, searchable: true, multiple: true }
    ],
    columns: [
      { field: 'role', label: 'Role' },
      { field: 'name', label: 'Name' },
      { field: 'email', label: 'Email' },
      { field: 'firstName', label: 'First Name' },
      { field: 'lastName', label: 'Last Name' },
      { field: 'dateOfBirth', label: 'Date of Birth' },
      { field: 'addressLine1', label: 'Address Line 1' },
      { field: 'addressLine2', label: 'Address Line 2' },
      { field: 'city', label: 'City' },
      { field: 'state', label: 'State' },
      { field: 'zip', label: 'Zip' },
      { field: 'church', label: 'Church' },
      { field: 'region', label: 'Region' },
      { field: 'homePhone', label: 'Home Phone' },
      { field: 'mobilePhone', label: 'Mobile Phone' }
    ],
    buildApiUrl: (filters, format) => {
      const roleIds = filters.roleIds?.join(',') || '';
      return `/api/reports/board-members?roleIds=${roleIds}&format=${format}`;
    }
  },
  
  'participant-roster': {
    filters: [
      { type: 'event', label: 'Select Event', required: true, searchable: true }
    ],
    columns: [
      { field: 'gender', label: 'Gender' },
      { field: 'firstName', label: 'First Name' },
      { field: 'lastName', label: 'Last Name' },
      { field: 'dateOfBirth', label: 'Date of Birth' },
      { field: 'placeOfBirth', label: 'Place of Birth' },
      { field: 'city', label: 'City' },
      { field: 'state', label: 'State' },
      { field: 'church', label: 'Church' },
      { field: 'specificAllergies', label: 'Specific Allergies' },
      { field: 'specificMedications', label: 'Specific Medications' }
    ],
    buildApiUrl: (filters, format) =>
      `/api/reports/participant-roster/${filters.eventId}?format=${format}`
  },

  'mailing-list': {
    filters: [],
    columns: [
      { field: 'firstName', label: 'First Name' },
      { field: 'lastName', label: 'Last Name' },
      { field: 'email', label: 'Email' },
      { field: 'address', label: 'Address' },
      { field: 'address2', label: 'Address 2' },
      { field: 'city', label: 'City' },
      { field: 'state', label: 'State' },
      { field: 'zip', label: 'Zip' }
    ],
    buildApiUrl: (filters, format) => 
      `/api/reports/mailing-list?format=${format}`
  },
  
  'insurance': {
    filters: [
      { type: 'event', label: 'Select Event', required: true, searchable: true }
    ],
    columns: [
      { field: 'firstName', label: 'First Name' },
      { field: 'lastName', label: 'Last Name' },
      { field: 'dateOfBirth', label: 'Date of Birth' },
      { field: 'beneficiary', label: 'Beneficiary' },
      { field: 'passportNumber', label: 'Passport Number' },
      { field: 'departureDate', label: 'Departure Date' },
      { field: 'returnDate', label: 'Return Date' }
    ],
    buildApiUrl: (filters, format) => 
      `/api/reports/insurance/${filters.eventId}?format=${format}`
  },
  
  'dr-volunteers': {
    filters: [
      { type: 'certification', label: 'Select Certification(s)', required: true, multiple: true },
      { type: 'region', label: 'Select Region(s)', required: true, multiple: true, options: [1,2,3,4,5,6,7,8,9,10,11] }
    ],
    columns: [
      { field: 'certification', label: 'Certification' },
      { field: 'expiresOn', label: 'Expires On' },
      { field: 'region', label: 'Region' },
      { field: 'userId', label: 'User ID' },
      { field: 'userName', label: 'User Name' },
      { field: 'alternateEmail', label: 'Alternate Email' },
      { field: 'firstName', label: 'First Name' },
      { field: 'middleName', label: 'Middle Name' },
      { field: 'lastName', label: 'Last Name' },
      { field: 'address', label: 'Address' },
      { field: 'address2', label: 'Address 2' },
      { field: 'city', label: 'City' },
      { field: 'state', label: 'State' },
      { field: 'zip', label: 'Zip' },
      { field: 'phone', label: 'Phone' },
      { field: 'mobilePhone', label: 'Mobile Phone' },
      { field: 'birthdate', label: 'Birthdate' },
      { field: 'church', label: 'Church' },
      { field: 'churchPhone', label: 'Church Phone' },
      { field: 'bgCheckDate', label: 'BG Check Date' },
      { field: 'bgCheckText', label: 'BG Check Text' }
    ],
    buildApiUrl: (filters, format) => {
      const certIds = filters.certificationIds?.join(',') || '';
      // Region is multi-select: send the chosen region numbers as a comma-separated list.
      const regionIds = (filters.regionIds && filters.regionIds.length)
        ? filters.regionIds.join(',')
        : (filters.regionId || '');
      return `/api/reports/dr-volunteers?certificationIds=${certIds}&regionId=${regionIds}&format=${format}`;
    }
  },
  
  'checked-in': {
    filters: [
      { type: 'event', label: 'Select Event', required: true, searchable: true }
    ],
    columns: [
      { field: 'userId', label: 'UserID' },
      { field: 'firstName', label: 'First Name' },
      { field: 'lastName', label: 'Last Name' },
      { field: 'email', label: 'Email' },
      { field: 'phone', label: 'Phone' },
      { field: 'registeredAs', label: 'Registered As' },
      { field: 'dateOfBirth', label: 'Date of Birth' },
      { field: 'approved', label: 'Approved' },
      { field: 'orderId', label: 'Order ID' },
      { field: 'checkedInDate', label: 'Checked In Date' },
      { field: 'backgroundCheckDate', label: 'Background Check Date' },
      { field: 'churchDate', label: 'Church' },
      { field: 'address', label: 'Address' },
      { field: 'address2', label: 'Address 2' },
      { field: 'city', label: 'City' },
      { field: 'state', label: 'State' },
      { field: 'zip', label: 'Zip' }
    ],
    buildApiUrl: (filters, format) => 
      `/api/reports/checked-in/${filters.eventId}?format=${format}`
  },
  
  'visa': {
    filters: [
      { type: 'event', label: 'Select Event', required: true, searchable: true }
    ],
    columns: [
      { field: 'passportGivenName', label: 'Passport Given Name' },
      { field: 'passportSurname', label: 'Passport Surname' },
      { field: 'dateOfBirth', label: 'Date of Birth' },
      { field: 'gender', label: 'Gender' },
      { field: 'stateOfBirth', label: 'State of Birth' },
      { field: 'nationality', label: 'Nationality' },
      { field: 'passportNumber', label: 'Passport Number' },
      { field: 'passportIssueDate', label: 'Passport Issue Date' },
      { field: 'passportExpiration', label: 'Passport Expiration' },
      { field: 'profession', label: 'Profession' }
    ],
    buildApiUrl: (filters, format) => 
      `/api/reports/visa/${filters.eventId}?format=${format}`
  }
};
